 const Sdata = [
    {
        id: 1,
         title: "Best Place To Choose Your Laptop",
         desc: "We provide republished branded laptop for our customer with reasonable price",
         cover: "https://i.ibb.co/7b00yB4/45240-88149-The-new-Mac-Book-Pro-16-inch-xl.jpg",
    },
    {
        id: 2,
        title: "Best Place To Choose Your Laptop",
        desc: "We provide republished branded laptop for our customer with reasonable price",
        cover: "https://i.ibb.co/N3sQxqC/download.jpg",
    },
    {
        id: 3,
        title: "Best Place To Choose Your Laptop",
        desc: "We provide republished branded laptop for our customer with reasonable price",
        cover: "https://i.ibb.co/R9TjZDc/download-1.jpg",
    },
    {
        id: 4,
        title: "Best Place To Choose Your Laptop",
        desc: "We provide republished branded laptop for our customer with reasonable price",
        cover: "https://i.ibb.co/nCzbtVW/hp-15s-spruce-blue-04-500x500-1.jpg",
    },
]

export default Sdata;